import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MaterTabsLayout.css';

type TMasterTabsLayoutProps = {
  tabs: React.ReactNode;
  selectedSubAgent: React.ReactNode | null;
  masterTab: React.ReactNode | null;
  subAgentsTab: React.ReactNode | null;
  isMasterTabActive: boolean;
};

export const MasterTabsLayout: React.FC<TMasterTabsLayoutProps> = ({
  tabs,
  selectedSubAgent,
  masterTab,
  subAgentsTab,
  isMasterTabActive,
}) => {
  return (
    <Responsive desktop>
      <div className={styles['container']}>
        <div className={styles['tabs']}>{tabs}</div>
        {isMasterTabActive ? (
          masterTab
        ) : (
          <>
            {selectedSubAgent}
            {subAgentsTab}
          </>
        )}
      </div>
    </Responsive>
  );
};
